import {
  grayLight,
  primaryMedium,
  whiteHard,
  grayHard,
  whiteLight,
  grayMedium,
} from 'styleVars/getColors';

export const styles = {
  root: {
    boxShadow: 'none',
  },
  expanded: {
    margin: 0,
    '&:last-child': {
      marginBottom: '30px',
    },
  },
  arrow: {
    color: primaryMedium,
    fontSize: '26px',
    fontFamily: '"Open Sans", sans-serif',
  },
  icon: {
    left: 'auto',
    right: '8px',
  },
  iconRtl: {
    left: '8px',
    right: 'auto',
  },
  header: {
    minHeight: '60px !important',
    background: '#ECECEC',
    color: primaryMedium,
    fontSize: '26px',
    fontWeight: 'bold',
    fontFamily: '"Open Sans", sans-serif',

    '& div:first-child': {
      margin: 0,
    },
  },
  hasTabs: {
    paddingLeft: 0,
  },
  hasBorderRadius: {
    borderTopLeftRadius: '15px',
    borderTopRightRadius: '15px',
    '&:before': {
      display: 'none',
    },
  },
  details: {
    padding: 0,
    border: `1px solid ${ grayLight }`,
  },
  disabled: {
    background: whiteHard,
    color: grayHard,
  },
  disabledHeader: {
    background: grayMedium,
    color: whiteLight,
    opacity: 1,
  },
};
